import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import '../../styles/FilterForArchive.css';
import Selector from '../CustomElements/Selector';
import Input from '../CustomElements/Input';
import { handleUniversalChange } from '../../utils/formUtils';
import Checkbox from '../CustomElements/Checkbox';

function FilterForArchiveServer({ formData, setFormData, handleChangeCheckbox, t }) {
  // получаем опции из стора
  const optionsForSelect = useSelector((state) => state.options);

  const { signals } = useSelector((state) => state?.archive?.archiveBrigadeSession);

  const [optionsTransferRails, setOptionsTransferRails] = useState([]);

  useEffect(() => {
    // Собираем все названия в один массив, разбивая строки на части
    const allNames = signals.reduce((acc, item) => {
      const names = item.transferRails ? item.transferRails.split(',').map((name) => name.trim()) : [];
      return [...acc, ...names];
    }, []);

    // Убираем повторения
    const uniqueNames = Array.from(new Set(allNames));

    // Преобразуем уникальные названия в массив опций для селекта
    const newOptions = uniqueNames.map((name) => ({
      value: name,
      label: name,
    }));

    setOptionsTransferRails(newOptions);
  }, [signals]);

  // опции для селектов
  const options = useMemo(
    () => ({
      dir: [
        { value: 0, label: t?.evenDirection || 'четное' },
        { value: 1, label: t?.oddDirection || 'нечетное' },
      ],
      inSafeZone: [
        { value: 0, label: t?.no || 'Нет' },
        { value: 1, label: t?.yes || 'Да' },
      ],
      uippsAlertType: [
        { value: '0', label: 'ОК' },
        { value: '1', label: t?.alert || 'Тревога' },
      ],
      alertType: [
        { value: 1, label: 'ОК' },
        { value: 5, label: t?.alert || 'Тревога' },
        { value: 2, label: t?.notification1 || 'Оповещение 1' },
        { value: 3, label: t?.notification2 || 'Оповещение 2' },
        { value: 0, label: t?.signalTypeFollowRC || 'Проследование РЦ' },
      ],
    }),
    [t]
  );

  return (
    <div className="filter-for-archive_select">
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData?.index}
        name="index"
        label={t?.signalIndex || 'Номер сигнала'}
        placeholder={t?.placeholderSignalNumber || 'Введите № сигнала'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData?.routeRailName}
        label={t?.controlledRoute || 'Контролируемая РЦ'}
        placeholder={t?.placeholderControlledRC || 'Введите РЦ, куда едет ПС'}
        name="routeRailName"
      />
      <Selector
        options={options?.alertType}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'alertType', selectedOption, 'select');
        }}
        value={
          formData?.alertType || formData?.alertType === 0
            ? options?.alertType?.find((option) => option.value === formData.alertType)
            : null
        }
        name="alertType"
        isMulti={false}
        label={t?.signalType || 'Тип сигнала'}
        placeholder={t?.placeholderSignalType || 'Выберите тип сигнала'}
      />
      <Selector
        options={options?.dir}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'dir', selectedOption, 'select');
        }}
        value={
          formData.dir || formData?.dir === 0 ? options?.dir?.find((option) => option.value === formData.dir) : null
        }
        name="dir"
        isMulti={false}
        label={t?.direction || 'Направление'}
        placeholder={t?.placeholderDirection || "Выберите направление"}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData.distance}
        name="distance"
        label={t?.labelApkDistance || 'Расстояние до ПС по АПК-ДК'}
        placeholder={t?.placeholderApkDistance || 'Введите расстояние в метрах'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData.warningRails}
        name="warningRails"
        label={t?.labelWarningRails || 'РЦ оповещения'}
        placeholder={t?.placeholderRailsNames || 'Введите названия, длины'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData.alertRails}
        name="alertRails"
        label={t?.labelAlertRails || 'РЦ тревоги'}
        placeholder={t?.placeholderRailsNames || 'Введите названия, длины'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event, null, null, null, null, null, 6)}
        value={formData.uippsId}
        name="uippsId"
        label={t?.uippsID || 'ID УИППС'}
        placeholder={t?.placeholderUippsId || 'Введите ID УИППС'}
      />
      <Selector
        options={options?.uippsAlertType}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'uippsAlertType', selectedOption, 'select');
        }}
        value={
          formData?.uippsAlertType
            ? options?.uippsAlertType?.find((option) => option.value === formData?.uippsAlertType)
            : null
        }
        name="uippsAlertType"
        isMulti={false}
        label={t?.uippsSignal || 'Сигнал на УИППС'}
        placeholder={t?.alertTypePlaceholder || 'Выберите сигнал'}
      />
      <Input
        onChange={(event) => handleUniversalChange(formData, setFormData, event)}
        value={formData.preciseDistance}
        name="preciseDistance"
        label={t?.coordDistance || 'Расстояние по координатам'}
        placeholder={t?.placeholderCoordDistance || 'Введите расстояние в метрах'}
      />
      <Checkbox
        height={`var(--sadr-font-size-45)`}
        // width={`var(--sadr-font-size-320)`}
        width={'100%'}
        label={t?.btnAlert || 'Кнопка «Тревога»'}
        onChange={(newValue) => handleChangeCheckbox('btnAlert', newValue)}
        checked={formData?.btnAlert}
        margin={'0px 0px 10px 0px'}
      />
      <Checkbox
        height={`var(--sadr-font-size-45)`}
        // width={`var(--sadr-font-size-320)`}
        width={'100%'}
        label={t?.btnClear || 'Кнопка «Путь свободен»'}
        onChange={(newValue) => handleChangeCheckbox('btnClear', newValue)}
        checked={formData?.btnClear}
        margin={'0px 0px 20px 0px'}
      />
      <Selector
        options={options?.inSafeZone}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'inSafeZone', selectedOption, 'select');
        }}
        value={
          formData?.inSafeZone || formData?.inSafeZone === 0
            ? options?.inSafeZone?.find((option) => option.value === formData?.inSafeZone)
            : null
        }
        name="inSafeZone"
        isMulti={false}
        label={t?.labelSafeZone || 'Контроль ИУ в безопасной зоне'}
        placeholder={t?.placeholderSafeZone || 'Выберите расположение ИУ'}
      />
      <Checkbox
        height={`var(--sadr-font-size-45)`}
        // width={`var(--sadr-font-size-320)`}
        width={'100%'}
        label={t?.btnFencing || 'Кнопка «Ограждение»'}
        onChange={(newValue) => handleChangeCheckbox('fencingBtnServer', newValue)}
        checked={formData?.fencingBtnServer}
        margin={'0px 0px 10px 0px'}
      />
      <Checkbox
        height={`var(--sadr-font-size-45)`}
        // width={`var(--sadr-font-size-320)`}
        label={t?.labelTransferRailsCheckbox || 'РЦ для переноса'}
        onChange={(newValue) => handleChangeCheckbox('transferRails', newValue)}
        checked={formData?.transferRails}
      />
      {/* <Selector
        options={optionsTransferRails}
        onChange={(selectedOption) => {
          handleUniversalChange(formData, setFormData, null, 'transferRails', selectedOption, 'select');
        }}
        value={optionsTransferRails?.find((option) => option.value === formData?.transferRails)}
        name="transferRails"
        isMulti={false}
        label={t?.labelTransferRails || "Перенос"}
        placeholder={t?.placeholderTransferRails || "Выберите РЦ для переноса"}
      /> */}
    </div>
  );
}

export default FilterForArchiveServer;
